module.exports = __webpack_public_path__ + "img/20.e54a4671.png";